module.exports = __webpack_public_path__ + "static/media/1B.e17e34f2.jpg";